import { Col, Row, Tooltip } from 'antd';
import { ExclamationCircleFilled, SyncOutlined } from '@ant-design/icons';
import NotSignedIcon from '../../../images/NotSignedIcon.svg';
import SignedIcon from '../../../images/SignedIcon.svg';
import countrySettings from '../countrySettings.json';

const SidebarExamList = ({
  examTabItems = [],
  activeExamTab,
  setActiveExamTab,
  itemHasReprovedValues,
  countryCode
}) => {
  const showReevaluationTags = countrySettings.medicalConsultation.reevaluationTags[countryCode];
  return (
    <div className="sidebar-exam-list">
      {examTabItems.map((item) => {
        const isActive = activeExamTab?.toString() === item.admission_patient_exam_id?.toString();
        const hasReproved = itemHasReprovedValues?.(item);
        const reevaluationType = item?.extra_data?.reevaluation_type;

        return (
          <button
            key={item.admission_patient_exam_id}
            type="button"
            className={`sidebar-exam-nav-btn ${isActive ? 'active' : ''}`}
            onClick={() => setActiveExamTab(item.admission_patient_exam_id?.toString())}
            aria-label={item.name}
            aria-current={isActive ? 'true' : undefined}
          >
            <Row align="middle" gutter={5} wrap={false}>
              {hasReproved && (
                <Col flex="none">
                  <Tooltip
                    title="Valor reprobatorio"
                    color="#223A70"
                    placement="right"
                    overlayClassName="sign-status-tooltip"
                  >
                    <ExclamationCircleFilled
                      style={{
                        color: '#D02A2A',
                        fontSize: 14,
                      }}
                    />
                  </Tooltip>
                </Col>
              )}
              <Col flex="1" style={{ minWidth: 0 }}>
                <Tooltip
                  title={item.name}
                  placement="right"
                  color="#223A70"
                  overlayClassName="sign-status-tooltip"
                >
                  <p className={`mb-0 sidebar-exam-name ${isActive ? 'active' : ''}`}>
                    {item.name}
                  </p>
                </Tooltip>
              </Col>
              {showReevaluationTags && (reevaluationType === 'reevaluation' || reevaluationType === 'observation_lift') && (
                <Col flex="none" className="sidebar-exam-reevaluation">
                  <Tooltip
                    title={reevaluationType === 'reevaluation' ? 'Reevaluación' : 'Levantamiento'}
                    placement="right"
                    overlayClassName="reevaluation-tooltip"
                  >
                    <SyncOutlined className="reevaluation-cycle-icon" />
                  </Tooltip>
                </Col>
              )}
              {item.need_expert_sign && (
                <Col flex="none">
                  <img
                    src={item.is_signed ? SignedIcon : NotSignedIcon}
                    alt="Icono de firma"
                    width={16}
                  />
                </Col>
              )}
            </Row>
          </button>
        );
      })}
    </div>
  );
};

export default SidebarExamList;
